export default "__VITE_ASSET__BqA8pXn2__"